import { IMruEntry, IFont, IFontFamily, IFontVariant } from '../FontPicker/FontPicker.types.shared';

/**
 * Check if a font is a theme font.
 * @param item - The font object to check.
 */
export function isThemeFont(f: IFont): boolean {
    return (f as IMruEntry).isThemeFont ?? false;
}

/**
 * Check if an object is an instance of {@link IFontFamily} interface.
 * @param item - The object to check.
 */
export function isFontFamily(item: unknown): item is IFontFamily {
    return (item as IFontFamily).name !== undefined && (item as IFontFamily).fontKey !== undefined;
}

/**
 * Check if an object is an instance of {@link IFontVariant} interface.
 * @param item - The object to check.
 */
export function isFontVariant(item: unknown): item is IFontVariant {
    return (
        (item as IFontVariant).name !== undefined && (item as IFontVariant).variantKey !== undefined
    );
}

/**
 * Check if an object is an instance of {@link IMruEntry} interface.
 * @param item - The object to check.
 */
export function isMruEntry(item: unknown): item is IMruEntry {
    return (item as IMruEntry).name !== undefined && (item as IMruEntry).mruKey !== undefined;
}

export function isFontMissing(font: IFont): boolean {
    return isMruEntry(font) && font.variantType === 'missing';
}

export function getFontKey(font: IFont): string {
    return isFontFamily(font) ? font.fontKey : isFontVariant(font) ? font.variantKey : font.mruKey;
}
